let SERVER={
    //线上环境
    EBASE_URL:'http://gateway.easygas.cn/ebase',
    //测试环境
    /* EBASE_URL:'http://gateway.easygas.cn/etbase', */
    //本地环境
   /*  EBASE_URL:'http://192.168.1.174:8885/ebase127', */
};
export default SERVER